<template>    
<svg width="5" height="17" viewBox="0 0 5 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="2.74028" cy="2.16924" r="2.00395" fill="#2F80ED"/>
<circle cx="2.74028" cy="8.16527" r="2.00395" fill="#2F80ED"/>
<circle cx="2.74028" cy="14.1613" r="2.00395" fill="#2F80ED"/>
</svg>
</template>
